import React, { useState } from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText, Button } from "@mui/material";

const MenuOptionsDropdown = ({ buttonIcon, menuItems = [], onOpen, onClose, className = "", menuClassName = "" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleButtonClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onOpen?.();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose?.();
  };

  return (
    <div>
      <span className="cursor-pointer" onClick={handleButtonClick}>
        {buttonIcon}
      </span>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: `${menuClassName}`,
          sx: {
            mt: 1,
            minWidth: 180,
            borderRadius: "8px",
          },
        }}
      >
        {menuItems.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={(event) => {
              event.stopPropagation();
              handleClose();
              item.onClick?.();
            }}
            className={`${className}`}
          >
            {item.icon && item.icon}
            <ListItemText className={item?.icon && "pl-3"}>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuOptionsDropdown;
